var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrau(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310.33 269.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1-2",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.01,
    y: 152.53,
    width: 0.65,
    height: 112.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.01,
    y: 152.53,
    width: 0.65,
    height: 112.83,
    transform: "translate(-130.07 103.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.93,
    y: 208.61,
    width: 112.83,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.93,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-130.14 103.99) rotate(-45.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.93,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-155.69 183.89) rotate(-67.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.01,
    y: 152.53,
    width: 0.65,
    height: 112.83,
    transform: "translate(-74.62 38.4) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.01,
    y: 152.52,
    width: 0.65,
    height: 112.83,
    transform: "translate(-155.68 183.78) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.93,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-74.67 38.44) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.93,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-156.2 229.1) rotate(-79.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.01,
    y: 152.53,
    width: 0.65,
    height: 112.83,
    transform: "translate(-106.9 69.92) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.01,
    y: 152.52,
    width: 0.66,
    height: 112.83,
    transform: "translate(-156.22 228.89) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.93,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-106.84 69.84) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.93,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-147.11 143.65) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.01,
    y: 152.53,
    width: 0.65,
    height: 112.83,
    transform: "translate(-40.12 16.05) rotate(-11.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.01,
    y: 152.52,
    width: 0.65,
    height: 112.83,
    transform: "translate(-147.08 143.58) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.93,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-40.14 16.07) rotate(-11.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.34,265.8a56.86,56.86,0,1,1,56.86-56.86A56.93,56.93,0,0,1,60.34,265.8Zm0-106.32a49.46,49.46,0,1,0,49.46,49.46A49.52,49.52,0,0,0,60.34,159.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.45,208.94a6.11,6.11,0,1,1-6.11-6.11A6.12,6.12,0,0,1,66.45,208.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.34,269.28a60.34,60.34,0,1,1,60.34-60.34A60.41,60.41,0,0,1,60.34,269.28Zm0-112.83a52.49,52.49,0,1,0,52.49,52.49A52.55,52.55,0,0,0,60.34,156.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.22,
    y: 132.75,
    width: 108.64,
    height: 5.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.85 210.2 82.72 146.33 85.52 141.28 173.65 205.15 170.85 210.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.69,103.73a12,12,0,0,0,0,24.09,3.25,3.25,0,0,0,0-6.49h0a5.56,5.56,0,0,1,0-11.12v0H92l-33.77,99L63.46,211l34.89-100.8A4.76,4.76,0,0,0,97,105.41a6.73,6.73,0,0,0-4.36-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.68,103.73h-24a12,12,0,0,0,0,24.09,3.25,3.25,0,0,0,0-6.49h0a5.56,5.56,0,0,1,0-11.12v0H92l-6.85,20.09H91.4l6.95-20.09A4.76,4.76,0,0,0,97,105.41,6.73,6.73,0,0,0,92.68,103.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.69,127.82a3.25,3.25,0,0,0,0-6.49h0a5.56,5.56,0,0,1,0-11.12v0h8.9v-6.46h-8.9a12,12,0,0,0,0,24.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "168.22 210.1 173.48 211.88 211.02 91.67 204.64 91.67 168.22 210.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.84,94.1a1.56,1.56,0,0,0,.18-1.95c-.61-1.31-2.2-4-7.29-3.78s-12.38,1.47-17.67,1-12.77-.44-16.35.55-4.64,2.88-3,3.52,6.3.82,11.61,1a35,35,0,0,1,11.23,2.11c2.71.88,3.17,1.51,5.5,1.23s5.76-2.5,8.84-3S222.55,94.5,222.84,94.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "175.51 224.95 175.34 223.66 249.58 213.75 249.75 215.05 175.51 224.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.74,
    y: 160.4,
    width: 1.96,
    height: 75.65,
    transform: "translate(-20.82 371.56) rotate(-79.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186,203.13s-5.59,3.19-9.7,1.85a6.17,6.17,0,0,0-2.83-2.79h0c-1.37-4.12,1.84-9.74,1.84-9.74l-4.47-1.17h0l-4.47,1.17s3.21,5.62,1.84,9.74h0A6.17,6.17,0,0,0,165.4,205c-4.11,1.34-9.7-1.85-9.7-1.85l-1.17,4.47h0l1.17,4.47s5.51-3.14,9.62-1.87a6.07,6.07,0,0,0,2.94,3c1.24,4.11-1.88,9.58-1.88,9.58l4.47,1.17h0l4.47-1.17s-3.12-5.47-1.88-9.58a6.07,6.07,0,0,0,2.94-3c4.11-1.27,9.62,1.87,9.62,1.87l1.17-4.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.85,225.57a17.89,17.89,0,1,1,17.89-17.89A17.92,17.92,0,0,1,170.85,225.57Zm0-33.17a15.28,15.28,0,1,0,15.27,15.28A15.3,15.3,0,0,0,170.85,192.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.63,209.58a5.55,5.55,0,0,1,2.1,2.07,50.87,50.87,0,0,0,6.07,8.75c2.64,2.88,7.16,8,7.16,8h4.67s-2.78-3.43-3.78-5.12a88.22,88.22,0,0,0-6.93-9.5c-2.36-2.68-4.8-4.92-5.2-5.91a9.58,9.58,0,0,0-1.54-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.2,231a3.08,3.08,0,0,1-3.08,3.08h-7.66a3.08,3.08,0,0,1-3.08-3.08h0a3.08,3.08,0,0,1,3.08-3.08h7.66A3.08,3.08,0,0,1,194.2,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.5,231a2.21,2.21,0,1,1-2.21-2.21A2.21,2.21,0,0,1,189.5,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.2,207.68a3.35,3.35,0,1,1-3.35-3.35A3.34,3.34,0,0,1,174.2,207.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.66,
    y: 152.53,
    width: 0.65,
    height: 112.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.66,
    y: 152.53,
    width: 0.65,
    height: 112.83,
    transform: "translate(-74.52 237.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.58,
    y: 208.61,
    width: 112.83,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.58,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-74.52 237.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.58,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-39.35 358.71) rotate(-67.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.66,
    y: 152.53,
    width: 0.65,
    height: 112.83,
    transform: "translate(-60.5 110.2) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.66,
    y: 152.52,
    width: 0.65,
    height: 112.83,
    transform: "translate(-39.37 358.67) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.58,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-60.54 110.33) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.58,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-2.09 415.35) rotate(-79.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.66,
    y: 152.53,
    width: 0.65,
    height: 112.83,
    transform: "translate(-74.19 176.39) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.66,
    y: 152.52,
    width: 0.66,
    height: 112.83,
    transform: "translate(-2.25 415.15) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.58,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-74.17 176.22) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.58,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-62.35 301.66) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.66,
    y: 152.53,
    width: 0.66,
    height: 112.83,
    transform: "translate(-36.37 53.55) rotate(-11.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.66,
    y: 152.52,
    width: 0.65,
    height: 112.83,
    transform: "translate(-62.38 301.55) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 193.58,
    y: 208.61,
    width: 112.83,
    height: 0.65,
    transform: "translate(-36.26 53.33) rotate(-11.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250,265.8a56.86,56.86,0,1,1,56.86-56.86A56.93,56.93,0,0,1,250,265.8Zm0-106.32a49.46,49.46,0,1,0,49.46,49.46A49.52,49.52,0,0,0,250,159.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.1,208.94a6.11,6.11,0,1,1-6.11-6.11A6.12,6.12,0,0,1,256.1,208.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250,269.28a60.34,60.34,0,1,1,60.34-60.34A60.41,60.41,0,0,1,250,269.28Zm0-112.83a52.49,52.49,0,1,0,52.49,52.49A52.55,52.55,0,0,0,250,156.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.69,205.23l-54.61-70.08-4.16,4L246,207.32a3.95,3.95,0,1,0,7.66,1.35A3.93,3.93,0,0,0,251.69,205.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107,0h-3.14c3.38,1.39,6.32,2.59,9.24,3.82a11.59,11.59,0,0,1,1.54.92c5.74,3.65,6,4.32,3.41,10.4-.57,1.38-1.14,2.76-2.06,4.95,2-.27,3.57-.18,4.89-.73,9.13-3.83,16.37-2.06,22.67,5.56,1.82,2.21,3.94,4.17,6,6.34l-2.2-.17c0,.14,0,.42.08.43a37.7,37.7,0,0,0,5.61,1.14,14.51,14.51,0,0,0,3.8-.77c3.1-.67,5.24.42,6.16,2.93-2.25-.14-4.76-.73-7.08-.3s-4.75,3-6.9,4c5.33,3.63,10.75,6,15.9,9.56,6.29,4.4,12.47,8.95,18.76,13.33a41,41,0,0,0,19.11,6.91c8.63,1,15.33,6.57,19.92,14.11s4.61,15.13.32,22.79c-.48.86-.83,1.79-1.24,2.69a3,3,0,0,1-.41.32,88.45,88.45,0,0,0-8.59,13.2c-4.57,8.7-10.25,16.82-15.56,25.12-1.88,2.95-4.19,5.63-6,8.63-1.19,2-1.81,4.32-2.86,6.91-.37-2-.67-3.63-1-5.26l-.75.13c.63,3.33,1.27,6.66,1.88,10,1.32,7.26,3.34,14.48,3.72,21.79.3,5.67-1.76,11.44-2.18,17.21-.5,6.94-.46,13.93-.45,20.9a9.27,9.27,0,0,0,1.55,4.14c1.83,3.21,1.26,6.59.77,9.92-.08.56-1.26,1.18-2,1.37-2.23.53-4.5.86-7,1.32,1.33,3.22-.68,3.78-3.08,4.17a50.36,50.36,0,0,0-6.45,1.39c-2.61.78-4.24.46-3.87-2.68-2.21-.59-4.37-.83-6.17-1.76-1.06-.55-1.54-2.2-2.28-3.36,1.07-.65,2.09-1.76,3.21-1.86,5.18-.47,8.77-2.92,12.44-6.72,5.64-5.84,4-12.39,3.65-18.88-.28-5.76-1-11.51-1.76-17.24-1.46-11.56-2.68-23.17-6.46-34.36.08.79.21,1.58.25,2.37.13,2.68.3,5.35.28,8,0,.45-.85,1-1.42,1.3-2.44,1.13-5,2.05-7.38,3.25-2.19,1.09-4,1.54-4.65-1.61-2.11,0-4.18.33-6.07-.12-1.14-.28-2-1.77-3-2.72.88-.72,1.65-1.77,2.66-2.12,4.43-1.55,8.59-3.42,8.91-8.84a9.24,9.24,0,0,0-1.43-5.78c-5.17-6.73-10.59-13.28-16.08-19.76-4.38-5.18-9-10.19-13.5-15.25a56.17,56.17,0,0,0-4.15-4.3c-6.4-5.76-5.85-11.38,1.54-15.54,2.88-1.62,5.71-3.33,8.51-5.07a76.25,76.25,0,0,1,27-10.28,34.83,34.83,0,0,0,6.55-1.55l-.23-.83c-3.27.81-.5,0-3.82.34a30,30,0,0,1-8.87-.39c-3.74-.69-7.33-2.24-11.08-2.87a17,17,0,0,0-7,.53c-6.74,1.79-8.42,1.33-12.52-4.25-.12-.17-.25-.32-.36-.48-5.37-7.49-5.22-10.88.82-17.91.23-.27.45-.55.67-.82l-.71-.48c-1.46,2.16-3.33,4.15-4.31,6.51-5.31,12.84-10.34,25.79-15.62,38.65a15.63,15.63,0,0,1-3.88,5.82c-3.39,2.94-6.26,2.07-8-2.19l.49,5c-2.51.48-4.62,1.54-6.73-.91-.55-.64-3,.18-4.48.57-.85.22-1.56,1.31-2.37,1.35-5.75.27-11.52.48-17.29.49-3.48,0-7-.39-10.46-.58-.62,0-1.25.16-1.87.16-2.57,0-5.14,0-7.7-.15-.22,0-.4-.81-.66-1.39-1.37,1.6-2.74,2-3.82-.38a1.53,1.53,0,0,0-.88-.59c-3.55-1-3.55-1-1.91-4.37l2.19-2.87c1.69-.6,3.39-1.69,5.09-1.71,7.88-.13,15.88.87,23.62-.12C77.4,99.3,86,96.58,94.57,94.3c1.11-.3,2.22-2,2.64-3.24C99.33,84.6,101,78,103.28,71.6a38.12,38.12,0,0,0,2.36-13.79c0-3.28.28-6.57.22-10l-1.25,6.42c-1.11-.29-2.27-.49-3.37-.89-4.16-1.5-8.21-2.48-12.46,0-1.93,1.15-3.86.59-4.73-2-.27-.79-1.19-1.33-1.61-2.09A10.1,10.1,0,0,1,82,46.93c-1.73-.55-2.58-3.89-5.75-3.39a4.3,4.3,0,0,1-.57-2,14.68,14.68,0,0,1,.73-2.28c.52-2.3,1.88-4.61-.36-6.87-.45-.45-.07-1.72-.07-1.84-3-2.09-5.85-4-8.5-6.11-.46-.38-.2-2.07.18-3,4.39-10.29,12-17,22.7-20.3C91.15,1,92,.74,93.67.27,92.32.12,91.8,0,91.27,0M91,8.55c-4.39,1.36-7.17,4.71-10.66,8.62,1.78-.25,3.2,0,3.7-.59,2.35-2.65,6.89-3.48,6.92-8.09a44.61,44.61,0,0,1,5.06-1c3.06-.23,6.15-.17,9.21-.44.5,0,.91-1.18,1.62-2.19C100.91,5.13,95.57,5.16,91,8.55Zm56.64,108.5c6.77,4.36,10.93,7.5,13.42,14.45,2.74,7.63,5.48,18.21,10.43,25.51,3-23.5,12.2-44.1,19.75-65.25-2.58,5.29-4.68,10.77-7.05,16.14-.57,1.29-1.86,2.91-3.08,3.17a109.91,109.91,0,0,1-15.29,2.36c-5.87.4-12.86,1-18.76,1.07M110,29.26c.44.83,1,1.39,1,2,.07,3.78,2.57,5.42,5.86,3.76a17.77,17.77,0,0,1,12.8-1.54c2,.51,16.64,4.7,19.43,5,0,0-14.83-9.63-16-11-.23.85-.76,3.11-1,4-.66-1.32-1-1.62-1.45-2.51-2.47-5.13-6.27-6.28-11.32-3.62a38.52,38.52,0,0,1-6.08,2.27c-.22.07-.68-.59-1-.92Zm6.61-13.89,0-.61c-3.13-.88-6.22-2.13-9.42-2.54a13,13,0,0,0-9.62,3.34l11.07-3.25-.3,1c.77.88,1.47,2.42,2.32,2.51A29.79,29.79,0,0,0,116.56,15.37Zm-41.81-.86c3.4.11,8.29-4.76,8.12-7.74ZM71,23.23V24l10-1.14-.06-.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 166.06,
    y: 175.5,
    width: 6,
    height: 29,
    transform: "matrix(0.98, -0.18, 0.18, 0.98, -30.86, 32.8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrau);
export default __webpack_public_path__ + "static/media/frau.704189d769070f10516cd8b4eea0f549.svg";
export { ForwardRef as ReactComponent };